/**
 * UI Components for EventStockReport
 */

import React from 'react';
import { useTranslate } from 'react-admin';
import DataGridTable from '../table/DataGridTable.jsx';
import CustomTableHeader from '../table/CustomTableHeader.jsx';
import { formatCurrency } from '../../utils/formatting';

export const SectionTitle = ({ children }) => <h3>{children}</h3>;

export const GridSection = ({ title, rows, columns, onColumnsVisibilityChange }) => {
  return (
    <div style={{ marginTop: 20 }}>
      <SectionTitle>{title}</SectionTitle>
      <DataGridTable
        rows={rows}
        columns={columns}
        hideFooter
        config={{ defaults: { pageSize: 25, visible: {} } }}
        onColumnsVisibilityChange={(model) => {
          onColumnsVisibilityChange && onColumnsVisibilityChange(model);
        }}
        slots={{ toolbar: CustomTableHeader }}
        density="compact"
      />
    </div>
  );
};

export const SummaryRow = ({ label, value, bold }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    <div>{label}</div>
    <div>{bold ? <b>{value}</b> : value}</div>
  </div>
);

export const SummarySection = ({
  event,
  totalProductSalesSummary,
  totalRemainingAmountSummary,
  totalCouponDiscountSummary,
  actualSalesData,
  subTotal,
  totalCommissionAmountSummary,
  checkIcon,
}) => {
  return (
    <div style={{ marginTop: 50, marginBottom: 50 }}>
      <SectionTitle>Summary</SectionTitle>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <div style={{ flex: 1, marginRight: 20 }}>
          <SummaryRow
            label="Total Product Sales:"
            value={formatCurrency(totalProductSalesSummary)}
            bold={true}
          />
          <SummaryRow
            label="Remaining Payments:"
            value={formatCurrency(totalRemainingAmountSummary)}
          />
          <SummaryRow
            label="Coupon Discounts:"
            value={formatCurrency(totalCouponDiscountSummary)}
          />
          <SummaryRow
            label="Sub Total:"
            value={formatCurrency(subTotal)}
            bold={true}
          />
        </div>
        <div style={{ flex: 1, marginLeft: 20 }}>
          <SummaryRow
            label="Total CC Sales:"
            value={formatCurrency(actualSalesData.totalAmountOfCCSales)}
          />
          <SummaryRow
            label="Total Cash Sales:"
            value={formatCurrency(actualSalesData.totalAmountOfCashSales)}
          />
          <SummaryRow
            label="Commission:"
            value={formatCurrency(totalCommissionAmountSummary)}
          />
          <SummaryRow
            label="Check:"
            value={checkIcon}
          />
        </div>
      </div>
    </div>
  );
};

export const ActionButtons = ({ onApprove, isApproved, isAdmin }) => {
  if (!isAdmin) return null;

  return (
    <div style={{ marginTop: 50, textAlign: 'center' }}>
      <button
        style={{
          backgroundColor: isApproved ? '#4CAF50' : '#FF9800',
          color: 'white',
          padding: '10px 20px',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          marginRight: '10px',
        }}
        onClick={onApprove}
      >
        {isApproved ? 'Approve Payment' : 'Make Payment'}
      </button>
    </div>
  );
};

export const LoadingSpinner = () => {
  const translate = useTranslate();
  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <div>{translate('ra.page.loading', { _: 'Yükleniyor...' })}</div>
    </div>
  );
};

export const EventHeader = ({ event }) => (
  <div style={{ textAlign: 'center', marginBottom: 50 }}>
    <h2>
      {event.name} - {new Date(event.startdate).toLocaleDateString()}
    </h2>
  </div>
);
